import type { Messages } from '../catalogue.en'

/**
 * Clinical: the encounter shell, schema-driven protocol authoring and
 *
 * Composed into the public catalogue by `catalogue.he.ts`. Nothing imports
 * this module directly: consumers ask the catalogue, so how the messages are
 * stored stays this layer's business.
 */
export const clinical: Partial<Messages> = {
  'clinical.parameters.title': "פרטי המפגש",
  'clinical.parameters.unset': "לא נבחר",
  'clinical.parameters.ruPlace': "מקום מתן הטיפול",
  'clinical.parameters.ruForm': "אופן מתן הטיפול",
  'clinical.parameters.ruType': "סוג הטיפול הרפואי",
  'clinical.parameters.ruVisitKind': "ביקור ראשון או חוזר",
  'clinical.parameters.ruCircumstances': "נסיבות הפנייה",
  'clinical.parameters.ilSetting': "מסגרת הטיפול",
  'clinical.parameters.ilContact': "סוג המגע (רשות)",
  'clinical.parameters.ilPriority': "עדיפות (רשות)",
  'clinical.parameters.ilService': "סוג השירות (רשות)",
  'clinical.parameters.ruHint': "הפרטים שייכים למפגש ומשותפים לכל הפרוטוקולים שלו. יש לבחור ערך בכל שדה לפני השלמת התיעוד. מצב המטופל ותוצאת הטיפול מתועדים בפרוטוקול.",
  'clinical.parameters.ilHint': "יש לבחור מסגרת טיפול. סוג המגע, העדיפות וסוג השירות הם שדות רשות. הפרטים שייכים למפגש ומשותפים לכל הפרוטוקולים שלו.",
  'clinical.parameters.suggested': "סוג הטיפול או השירות מולא לפי הבחירה האחרונה שאישרת לפרוטוקול זה. יש לבדוק אותו לפני השמירה.",
  'clinical.parameters.unbound': "לא הוגדר מקור מונחים מתאים לשדה זה. יש לפנות למנהל המערכת.",
  'clinical.parameters.noProfile': "פרטי המפגש אינם זמינים: יש לבחור למרפאה פרופיל מונחים לאומי נתמך.",
  'clinical.parameters.loading': "פרטי המפגש בטעינה…",
  'clinical.parameters.loadFailed': "לא ניתן לטעון את פרטי המפגש.",
  'clinical.parameters.unsaved': "פרטי מפגש שלא נשמרו",
  'clinical.parameters.save': "שמירת פרטי המפגש",
  'clinical.parameters.saving': "פרטי המפגש נשמרים…",
  'clinical.parameters.saved': "פרטי המפגש נשמרו.",
  'clinical.parameters.saveFailed': "לא ניתן לשמור את הפרטים. השינויים נשמרו בטופס.",
  'clinical.parameters.invalid': "יש לבדוק את הערכים שנבחרו. השינויים נשמרו בטופס.",
  'clinical.parameters.required': "יש למלא ולשמור את פרטי המפגש לפני השלמת התיעוד.",
  'clinical.parameters.changed': "פרטי המפגש השתנו במקום אחר. יש לטעון את הגרסה השמורה לפני השמירה.",
  'clinical.parameters.profileChanged': "פרופיל המונחים הלאומי השתנה. יש לטעון את הפרטים השמורים ולבדוק את הבחירות.",
  'clinical.parameters.readOnly': "פרטי המפגש זמינים לקריאה בלבד.",
  'clinical.parameters.resetPreference': "מחיקת סוג הטיפול או השירות שנזכר",
  'clinical.parameters.resetFailed': "לא ניתן למחוק את הבחירה שנזכרה.",
  'clinical.parameters.preferenceReset': "הבחירה שנזכרה נמחקה. פרטי המפגש הנוכחי נשמרו.",
  'clinical.parameters.reload': "טעינת הפרטים השמורים",
  'clinical.parameters.reloadFailed': "לא ניתן לטעון את הפרטים השמורים. השינויים נשמרו בטופס.",
  'clinical.parameters.reloaded': "הטופס מציג כעת את הפרטים השמורים.",
  'clinical.startVisit': 'התחלת מפגש',
  'clinical.startingVisit': 'מתחיל',
  'clinical.openVisit': 'פתיחת מפגש',
  'clinical.openingVisit': 'פותח',
  'clinical.notStartable': 'לא ניתן להתחיל',
  'clinical.startMissingCapability': 'אין גישת מפגש',
  'clinical.startForbidden': 'אין לך הרשאה להתחיל מפגש זה.',
  'clinical.startStale': 'התור אינו זמין עוד.',
  'clinical.alreadyStartedMissingLink': 'המפגש התחיל, אך הקישור שלו אינו זמין.',
  'clinical.startConflict': 'התור כבר מקושר באופן שונה. רענן את היומן.',
  'clinical.startInvalid': 'לא ניתן היה להתחיל מפגש מתור זה.',
  'clinical.startMalformed': 'תגובת המפגש חסרה פרטים.',
  'clinical.startUnavailable': 'לא ניתן לפתוח את המפגש כעת. נסה שוב.',
  'clinical.startFailed': 'לא ניתן היה לפתוח את המפגש.',
  'clinical.encounterTitle': 'מפגש',
  'clinical.loading': 'טוען מפגש',
  'clinical.practitionerRequired': 'נדרש חשבון קליני',
  'clinical.practitionerRequiredDetail': 'מפגש זה יכול להיפתח רק על ידי חשבון שמקושר למטפל.',
  'clinical.practitioner': 'מטפל',
  'clinical.appointmentTime': 'שעת התור',
  'clinical.caseCode': 'קוד תיק',
  'start.title': 'התחלת מפגש',
  'start.detail': 'בחר לאיזה תיק שייך המפגש, או פתח תיק חדש. כל מפגש משויך לתיק.',
  'start.promptLabel': 'התחלת מפגש עבור {name}',
  'start.chooseCase': 'תיק עבור מפגש זה',
  'start.caseNoneOpen': 'למטופל זה אין תיק פתוח, ולכן מפגש זה פותח תיק חדש.',
  'start.caseChoose': 'בחר לאיזה תיק שייך המפגש.',
  'start.confirm': 'התחל',
  'start.starting': 'מתחיל…',
  'start.cancel': 'ביטול',
  'caseChoice.new': 'יצירת תיק חדש',
  'caseChoice.preselected': 'התיק הפתוח היחיד נבחר.',
  'caseChoice.titleLabel': 'כותרת התיק',
  'caseChoice.commentLabel': 'הערה',
  'caseChoice.startLabel': 'תאריך התחלה',
  'caseChoice.endLabel': 'תאריך סיום',
  'caseChoice.titleRequired': 'נדרשת כותרת לתיק.',
  'caseChoice.ineligibleHidden':
    '{count} תיקים שהושלמו או בוטלו אינם מוצגים: תיק סגור אינו יכול לקלוט מפגש חדש.',
  'clinical.status.inProgress': 'בתהליך',
  'clinical.status.finished': 'הושלם',
  'clinical.status.enteredInError': 'נרשם בטעות',
  'clinical.invalidDeepLink': 'קישור המפגש אינו תקין',
  'clinical.invalidDeepLinkDetail': 'פתח את המפגש שוב מהיומן.',
  'clinical.staleEvent': 'קישור המפגש אינו עדכני',
  'clinical.staleEventDetail': 'רענן את היומן ופתח את המפגש שוב.',
  'clinical.encounterNotFound': 'המפגש לא נמצא',
  'clinical.encounterNotFoundDetail': 'מפגש זה אינו זמין במרפאה שלך.',
  'clinical.sessionExpiredDetail': 'היכנס שוב כדי להמשיך.',
  'clinical.unavailable': 'לא ניתן היה לטעון את הדף',
  'clinical.unavailableDetail': 'בדוק את החיבור ונסה שוב.',
  'clinical.invalidResponse': 'תגובת השרת חסרה פרטים',
  'clinical.invalidResponseDetail': 'נסה שוב, או בקש ממנהל לבדוק את Core.',

  'record.title': 'רשומה קלינית',
  'record.detailTitle': 'פרטי רשומה קלינית',
  'record.loading': 'טוען את הרשומה הקלינית…',
  'record.loadFailed': 'לא ניתן היה לטעון את הרשומה הקלינית.',
  'record.forbidden': 'אין לך הרשאה לכתוב רשומות קליניות.',
  'record.sessionEnded': 'ההתחברות הסתיימה. התחבר שוב כדי להמשיך.',
  'record.gone': 'הרשומה הקלינית אינה זמינה עוד.',
  'record.invalidInput': 'השרת דחה את הרשומה. בדוק את השדות ונסה שוב.',
  'record.saveFailed': 'לא ניתן היה לשמור את הרשומה. נסה שוב.',
  'record.workplaceRequired': 'יש לבחור מקום עבודה למסמך זה.',
  'record.workplaceUnavailable': 'מקום העבודה של מסמך זה אינו זמין עוד לכתיבה. יש לעדכן את הקשר המחבר לפני שממשיכים.',
  'record.authorWorkplace': 'מקום העבודה של המחבר',
  'record.changeWorkplace': 'שינוי מקום העבודה של המחבר',
  'record.workplaceNotRecorded': 'לא תועד',
  'record.workplaceUnsavedIntent': 'מקום העבודה של מחבר המסמך הרפואי',
  'record.workplaceProtocolIncompatible': 'מקום העבודה שנבחר דורש פרוטוקול אחר. המסמך והנתונים שהוזנו לא השתנו.',
  'record.noRelease': 'אין פרוטוקול מפורסם זמין.',
  'record.noReleaseDetail': 'יש לפרסם פרוטוקול קליני לפני כתיבת רשומות.',
  'record.invalidSchema': 'לא ניתן להציג את הפרוטוקול המפורסם בגרסה זו של היישום.',
  'record.unsupportedField': 'סוג שדה זה אינו נתמך בגרסה זו',
  'record.fieldRequired': 'יש למלא שדה זה לפני סגירת הרשומה.',
  'record.codedSearch': 'חיפוש במילון המונחים',
  'record.codedClear': 'ניקוי ערך מקודד',
  'record.choiceUnanswered': 'לא נענה',
  'record.codedUnavailable': 'מילון המונחים אינו זמין. התשובה הנוכחית נשמרת.',
  'record.referenceNone': 'לא נבחר שירות',
  'record.referenceUnavailable': 'שירותי המרפאה אינם זמינים. הבחירה הנוכחית נשמרת.',
  'record.create': 'צור רשומה',
  'record.save': 'שמור',
  'record.conflict':
    'הרשומה שונתה במקום אחר. טען את הגרסה השמורה כדי להמשיך; השינויים שלא נשמרו יימחקו.',
  'record.reloadServerVersion': 'טען את הגרסה השמורה',
  'record.stateNew': 'לא נוצרה',
  'record.stateSaved': 'נשמר',
  'record.stateUnsaved': 'שינויים שלא נשמרו',
  'record.unsavedIntent': 'רשומה קלינית — שינויים שלא נשמרו',
  'record.primaryUnsavedIntent': 'פרוטוקול ראשי — שינויים שלא נשמרו',
  'record.primaryTranslationUnsavedIntent': 'תרגום הפרוטוקול הראשי — שינויים שלא נשמרו',
  'record.stateSaving': 'שומר…',
  'record.stateFinal': 'סופית',
  'record.printLoading': 'טוען טופסי הדפסה',
  'record.printPdf': 'הדפס PDF',
  'record.printLanguage': 'שפת ההדפסה',
  'record.printingPdf': 'מכין PDF…',
  'record.printDownloaded': 'ה-PDF הורד.',
  'record.printFailed': 'לא ניתן היה להכין את ה-PDF. נסה שוב.',
  'record.printForbidden': 'אין לך הרשאה להדפיס רשומה זו.',
  'record.printUnavailable': 'הרשומה אינה מוכנה להדפסה.',
  'record.printConflict': 'בקשת ההדפסה השתנתה בזמן ההכנה. נסה שוב.',
  'record.dictationOpen': 'הכתבה',
  'record.dictationTitle': 'הכתבה ועוזר בינה מלאכותית',
  'record.dictationIntro':
    'יש להכתיב לפי נושאי הפרוטוקול. לאחר העצירה ההקלטה נשלחת ל-OpenAI לתמלול ולסידור בשדות.',
  'record.dictationTopics': 'נושאי דיבור מוצעים מתוך הפרוטוקול של רשומה זו:',
  'record.dictationNoTopics': 'לפרוטוקול זה אין שדות שיכולים לקבל טקסט מוכתב.',
  'record.dictationSourceLanguage': 'שפת הדיבור',
  'record.dictationOutputLanguage': 'שפת הרשומה',
  'record.dictationLanguageAuto': 'זיהוי אוטומטי',
  'record.dictationStart': 'התחלת הקלטה',
  'record.dictationRetry': 'הקלטה מחדש',
  'record.dictationStop': 'עצירה',
  'record.dictationTimer': 'משך ההקלטה',
  'record.dictationRequesting': 'מבקש גישה למיקרופון…',
  'record.dictationRecording': 'מקליט…',
  'record.dictationProcessing': 'מתמלל ומסדר את שדות הפרוטוקול…',
  'record.dictationReady': 'יש לבדוק את התמלול ואת השדות שזוהו לפני החלתם.',
  'record.dictationTranscript': 'תמלול',
  'record.dictationExtracted': 'שדות שזוהו',
  'record.dictationNoExtracted': 'לא זוהה תוכן עבור שדות הפרוטוקול.',
  'record.dictationUnassigned': 'תוכן שלא שובץ בשדה',
  'record.dictationWarnings': 'אזהרות',
  'record.dictationApply': 'החלה על הטיוטה',
  'record.dictationPermissionDenied': 'הגישה למיקרופון נדחתה. יש לאפשר גישה ולנסות שוב.',
  'record.dictationMicrophoneFailed': 'לא ניתן היה להפעיל את המיקרופון.',
  'record.dictationUnsupportedBrowser': 'דפדפן זה אינו יכול להקליט שמע להכתבה.',
  'record.dictationKeyMissing': 'יש להוסיף את מפתח ה-OpenAI האישי בהגדרות הפרופיל לפני השימוש בהכתבה.',
  'record.dictationSchemaChanged': 'הפרוטוקול השתנה. יש לסגור את החלון ולטעון מחדש את הרשומה.',
  'record.dictationTooLarge': 'ההקלטה גדולה מ-{max} MB. יש להקליט פרוטוקול קצר יותר.',
  'record.dictationUnsupportedAudio': 'הדפדפן יצר תבנית שמע שאינה נתמכת.',
  'record.dictationForbidden': 'אין לך הרשאה להשתמש בהכתבה עבור רשומה זו.',
  'record.dictationFailed': 'לא ניתן היה לעבד את ההקלטה. יש לנסות שוב.',
  'record.dictationClose': 'סגירה',
  'correction.alreadyCorrected':
    'רשומה זו כבר הוחלפה על ידי מישהו אחר. פתח את היסטוריית התיקונים כדי לקרוא את ההחלפה — השינוי שלך לא הוחל.',
  'correction.idempotencyConflict':
    'תיקון זה כבר נשלח עם פרטים אחרים. דבר לא הוחלף. התחל את התיקון מחדש במקום לשלוח שוב.',
  'correction.changedConcurrently': 'הרשומה השתנתה בזמן שקראת אותה. טען אותה מחדש לפני תיקון.',
  'correction.forbidden': 'אין לך הרשאה לתקן רשומה זו.',
  'correction.gone': 'רשומה זו אינה זמינה עוד.',
  'correction.invalidInput': 'בדוק את נימוק התיקון.',
  'correction.failed': 'לא ניתן היה להשלים את התיקון.',
  'correction.historyLoading': 'בודק היסטוריית תיקונים',
  'correction.historyUnavailable': 'לא ניתן היה לקרוא את היסטוריית התיקונים.',
  'correction.wasReplaced': 'רשומה זו הוחלפה',
  'correction.replacesAnother': 'רשומה זו מחליפה רשומה קודמת',
  'correction.reason': 'נימוק התיקון',
  'correction.correctedAt': 'תוקן',
  'correction.openReplacement': 'פתח את ההחלפה',
  'correction.openOriginal': 'פתח את הרשומה שהוחלפה',
  'correction.amend': 'תקן רשומה',
  'correction.markEnteredInError': 'סמן כנרשם בטעות',
  'correction.showHistory': 'היסטוריה',
  'correction.amendTitle': 'תיקון הפרוטוקול',
  'correction.amendBody': 'בחר את הסיבה. המסמך הנוכחי יישאר ללא שינוי כמסמך שהוחלף, ותיווצר טיוטת תיקון חדשה עם אותו תוכן.',
  'correction.enteredErrorTitle': 'סימון הפרוטוקול כנרשם בטעות',
  'correction.enteredErrorBody': 'בחר את הסיבה. המסמך לא יהיה עוד המסמך הנוכחי ולא תיווצר לו החלפה.',
  'correction.amending': 'יוצר תיקון…',
  'correction.markingEnteredError': 'מסמן כנרשם בטעות…',
  'correction.reasonClinicalError': 'תיקון קליני',
  'correction.reasonWrongPatient': 'מטופל שגוי',
  'correction.reasonWrongProtocol': 'פרוטוקול שגוי',
  'correction.reasonMissingInformation': 'חסר מידע',
  'correction.reasonDuplicateEntry': 'פרוטוקול כפול',
  'correction.reasonOther': 'נימוק אחר',
  'correction.reasonDetail': 'הנימוק במילים שלך',
  'correction.historyTitle': 'היסטוריית פרוטוקול',
  'correction.historyEmpty': 'אין גרסאות בארכיון.',
  'correction.historyEnteredError': 'נרשם בטעות',
  'correction.historyAmended': 'תוקן באמצעות החלפה',
  'correction.confirmAmendment': 'אשר תיקון',
  'correction.cancel': 'השאר את הרשומה כפי שהיא',
  'record.fieldEmpty': 'לא תועד',
  'record.unrepresentedTitle': 'תוכן שגרסה זו אינה יכולה להציג',
  'record.unrepresentedDetail':
    'הפרוטוקול השמור מכיל ערכים אלה, והיישום אינו יודע היכן למקם אותם. הם מפורטים כדי שדבר לא יושמט בשקט.',
  'record.draftNotice': 'זוהי טיוטה. אין זו ראיה קלינית חתומה.',
  'record.evidence': 'סגירת הרשומה',
  'record.finalizedAt': 'נסגרה',
  'record.protocol': 'פרוטוקול',
  'record.protocolLoading': 'טוען פרוטוקול…',
  'record.protocolUnavailable': 'שם הפרוטוקול אינו זמין',
  'record.status': 'סטטוס רשומה',

  'clinical.completeEntry': 'השלמת הרישום',
  'clinical.completing': 'משלים…',
  'clinical.completeConfirmTitle': 'אישור השלמת הרישום',
  'clinical.completeConfirmBody':
    'ההשלמה מאשרת את כל הפרוטוקולים הנוכחיים וסוגרת את המפגש ואת התור. המפגש הקליני לא ייפתח מחדש.',
  'clinical.completeConfirm': 'השלם לצמיתות',
  'clinical.completeCorrection': 'השלמת התיקון',
  'clinical.completingCorrection': 'משלים את התיקון…',
  'clinical.completeCorrectionConfirmTitle': 'אישור השלמת התיקון',
  'clinical.completeCorrectionConfirmBody':
    'ההשלמה מאשרת את כל הפרוטוקולים הנוכחיים וסוגרת את סביבת התיקון. המפגש והתור שהושלמו נשארים ללא שינוי.',
  'clinical.completeCorrectionConfirm': 'השלם את התיקון',
  'clinical.completeCancel': 'השאר את הרישום פתוח',
  'clinical.completeConflict':
    'לא ניתן היה להשלים את הרישום מפני שמצבו הקליני השתנה. טען מחדש כדי לראות את מצבו הנוכחי.',
  'clinical.completeForbidden': 'אין לך הרשאה להשלים רישומים.',
  'clinical.completeSessionEnded': 'ההתחברות הסתיימה. התחבר שוב כדי להמשיך.',
  'clinical.completeGone': 'הרישום אינו זמין עוד.',
  'clinical.completeUnavailable': 'השירות אינו זמין. נסה שוב בקרוב.',
  'clinical.completeFailed': 'לא ניתן היה להשלים את הרישום. נסה שוב.',
  'clinical.completeAlreadyFinished': 'הרישום כבר הושלם. טען מחדש כדי לראות את מצבו הנוכחי.',
  'clinical.completeMainDiagnosisRequired':
    'לרישום זה אין אבחנה ראשית. רשום אבחנה ראשית במקטע האבחנות ולאחר מכן השלם את הרישום.',
  'clinical.completeProtocolInvalid':
    'לא ניתן לאשר פרוטוקול אחד או יותר במצבם הנוכחי. מלא את שדות החובה ונסה שוב.',
  'clinical.completeSaveProtocolsFirst': 'יש לשמור את כל השינויים בפרוטוקולים לפני ההשלמה.',
  'clinical.completeEnteredInError': 'רישום זה סומן כנרשם בטעות ולא ניתן להשלים אותו.',
  'clinical.completeChangedConcurrently':
    'הרישום השתנה במקום אחר בזמן שמסך זה היה פתוח. טען מחדש כדי לראות את מצבו הנוכחי.',
  'clinical.completeNotFinishable':
    'לא ניתן להשלים את הרישום במצבו הנוכחי. טען מחדש כדי לראות אותו.',
  'clinical.completeScheduleNotCloseable':
    'לא ניתן היה לסגור את התור המקושר, ולכן דבר לא הושלם. בדוק את התור ונסה שוב.',
  'clinical.completeCorrectionNotOpen':
    'אין תיקון פתוח להשלמה. טען מחדש כדי לראות את מצב התיעוד הנוכחי.',

  'clinical.sectionDiagnoses': 'אבחנות',
  'clinical.entryCompleted': 'הביקור והתיעוד שלו הושלמו. הפרוטוקולים לקריאה בלבד עד לפתיחת תיקון.',
  'clinical.entryCorrectionOpen': 'תיקון תיעוד מתבצע. המפגש הקליני והתור נשארים במצב הושלם.',
  'clinical.entryEnteredInError': 'רישום זה סומן כנרשם בטעות והוא לקריאה בלבד.',
  'clinical.encounterStarted': 'התחיל',
  'clinical.encounterType': 'סוג רישום',
  'clinical.typeScheduled': 'מפגש מתוכנן',
  'clinical.typeUnscheduled': 'מפגש לא מתוכנן',

  'encounterProtocols.title': 'פרוטוקולים',
  'encounterProtocols.forbidden': 'אין לך הרשאה לקרוא רשומות קליניות.',
  'encounterProtocols.statusDraft': 'טיוטה',
  'encounterProtocols.statusFinal': 'סופי',
  'encounterProtocols.statusAmended': 'תוקן',
  'encounterProtocols.statusEnteredInError': 'נרשם בטעות',

  'encounterNav.entryLabel': 'רישום זה',
  'encounterNav.entryCodeLabel': 'קוד הרישום',
  'encounterNav.menuLabel': 'מקטעי הרישום',
  'encounterNav.addDescription': 'התחל רשומה נוספת ברישום זה',
  'encounterNav.diagnosesDescription': 'מה שנקבע ברישום זה',
  'encounterNav.referrals': 'הפניות',
  'encounterNav.referralsDescription': 'מה שנשלח הלאה מרישום זה',
  'encounterNav.services': 'שירותים',
  'encounterNav.servicesDescription': 'שירותים שבוצעו וחיובים עבור רישום זה',
  'encounterNav.protocolHistoryDescription': 'גרסאות פרוטוקול בארכיון',
  'encounterNav.protocolHistoryMeta': 'היסטוריה',
  'encounterNav.printGroupLabel': 'הדפסת PDF',

  'addProtocol.title': 'הוספת פרוטוקול',
  'addProtocol.detail': 'רשומה חדשה נוצרת ריקה ונשמרת. דבר אינו ננעל כאן.',
  'addProtocol.assignmentInactive': "הפרוטוקול שנבחר אינו זמין לרשומות חדשות. יש לבחור פרוטוקול אחר.",
  'addProtocol.legend': 'איזה פרוטוקול',
  'addProtocol.submit': 'התחל פרוטוקול',
  'addProtocol.submitting': 'מתחיל…',
  'addProtocol.alreadyStarted': 'פרוטוקול זה כבר הותחל ברישום זה. סגור חלונית זו כדי לראות אותו.',

  'referral.title': 'הפניה',
  'referral.sectionTitle': 'הפניות',
  'referral.emptyEncounter': 'אין עדיין הפניות ברישום זה.',
  'referral.emptyEncounterDetail': 'הפניה נוצרת מרשומת ייעוץ שננעלה. נעל את הרשומה וחזור לכאן.',
  'referral.otherGroup': 'הפניות מרשומות שאינן מוצגות למעלה',
  'referral.detailTitle': 'פרטי הפניה',
  'referral.loading': 'טוען הפניות…',
  'referral.loadFailed': 'לא ניתן היה לטעון את ההפניות.',
  'referral.forbidden': 'אין לך הרשאה לעבוד עם הפניות.',
  'referral.notFound': 'ההפניה אינה זמינה.',
  'referral.invalidInput': 'השרת דחה את ההפניה. בדוק את השדות ונסה שוב.',
  'referral.saveFailed': 'לא ניתן היה לשמור את ההפניה. נסה שוב.',
  'referral.conflict':
    'לא ניתן היה לשמור את ההפניה כיוון שהשתנתה. טען מחדש כדי לראות את מצבה הנוכחי.',
  'referral.changedConcurrently':
    'ההפניה שונתה במקום אחר. טען מחדש כדי לראות את הגרסה השמורה לפני שתמשיך.',
  'referral.sourceMismatch': 'הפניה זו אינה שייכת לרשומה המוצגת כאן. טען מחדש לפני שתמשיך.',
  'referral.priority': 'דחיפות',
  'referral.priorityRoutine': 'שגרתי',
  'referral.priorityUrgent': 'דחוף',
  'referral.specialty': 'התמחות',
  'referral.specialtyChoose': 'בחר התמחות',
  'referral.specialtiesLoading': 'טוען את ההתמחויות שהפניה זו מקבלת…',
  'referral.specialtiesUnavailable':
    'לא ניתן היה לטעון את ההתמחויות שהפניה זו מקבלת, ולכן לא ניתן ליצור כאן הפניה כעת.',
  'referral.recipient': 'הפניה אל',
  'referral.reason': 'סיבת ההפניה',
  'referral.note': 'הערה (אופציונלי)',
  'referral.specialtyRequired': 'יש לציין התמחות.',
  'referral.recipientRequired': 'יש לציין נמען.',
  'referral.reasonRequired': 'יש לציין סיבה להפניה.',
  'referral.create': 'צור הפניה',
  'referral.newReferral': 'הפניה חדשה',
  'referral.cancelEditor': 'ביטול',
  'referral.created': 'הפניה {code} נוצרה.',
  'referral.save': 'שמור הפניה',
  'referral.editDraft': 'ערוך טיוטה',
  'referral.activate': 'הפעל הפניה',
  'referral.stateDraft': 'טיוטה',
  'referral.stateActive': 'פעילה',
  'referral.stateEnteredInError': 'הוזנה בטעות',
  'referral.activeImmutable': 'ההפניה פעילה ולא ניתן לשנותה עוד.',
  'referral.status': 'סטטוס הפניה',
  'referral.authoredAt': 'נכתבה',
  'referral.activatedAt': 'הופעלה',
  'referral.sourceRecord': 'רשומת מקור',
  'referral.sourceWorkplace': 'מתוך רשומת המקור',
  'addProtocol.inheritedWorkplace': 'מתוך הביקור',
  'correction.unsavedIntent': 'סיבת תיקון המסמך הרפואי ומקום העבודה',

  'referral.sourceUnavailable': 'הרשומה שממנה נוצרה ההפניה אינה זמינה.',
  'referral.sourceNotFinal':
    'הרשומה אינה סופית עוד ולכן לא ניתן ליצור ממנה הפניה. טען מחדש כדי לראות את מצבה הנוכחי.',
  'referral.sourceUnsupported': 'לא ניתן ליצור הפניה מסוג רשומה זה.',
  'referral.specialtyUnsupported':
    'ההתמחות אינה נתמכת עבור סוג הפניה זה. השתמש בהתמחות שהגדרת ההפניה מתירה.',

  'referral.discard': 'בטל טיוטה',
  'referral.discardConfirmBody':
    'ביטול מסיר את טיוטת ההפניה. היא נשמרת כרשומה מבוטלת יחד עם הסיבה, ואינה נמחקת.',
  'referral.discardReason': 'סיבת הביטול',
  'referral.discardReasonRequired': 'יש לציין סיבה לפני ביטול הטיוטה.',
  'referral.discardConfirm': 'בטל לצמיתות',
  'referral.discardCancel': 'השאר את הטיוטה',
  'referral.unsavedIntent': 'הפניה — פרטים שלא נשמרו',
  'referral.unsavedDiscardReason': 'ביטול הפניה — נימוק שלא נשלח',
  'referral.idempotencyConflict': 'הביטול כבר נרשם עם סיבה אחרת. טען מחדש כדי לראות מה נשמר.',
  'referral.notDraft': 'ההפניה הופעלה ולא ניתן לשנותה עוד. טען מחדש כדי לראותה.',
  'diagnosis.title': 'אבחנות',
  'diagnosis.loading': 'טוען אבחנות…',
  'diagnosis.loadFailed': 'לא ניתן היה לטעון את הקשר האבחנות.',
  'diagnosis.forbidden': 'אין לך הרשאה לקרוא אבחנות.',
  'diagnosis.empty': 'טרם נרשמו אבחנות',
  'diagnosis.emptyDetail': 'רשום תחילה את האבחנה הראשית של המפגש.',
  'diagnosis.mainRequired': 'לרישום זה אין אבחנה ראשית. נדרשת אבחנה ראשית לפני השלמתו.',
  'diagnosis.mainRecorded': 'נרשמה אבחנה ראשית לרישום זה.',
  'diagnosis.roleMain': 'ראשית',
  'diagnosis.roleComplication': 'סיבוך',
  'diagnosis.roleConcomitant': 'נלווית',
  'diagnosis.roleAdditional': 'נוספת',
  'diagnosis.clinicalActive': 'פעילה',
  'diagnosis.clinicalInactive': 'לא פעילה',
  'diagnosis.clinicalResolved': 'נפתרה',
  'diagnosis.verificationConfirmed': 'מאושרת',
  'diagnosis.verificationProvisional': 'אבחנה זמנית',
  'diagnosis.verificationRefuted': 'נשללה',
  'diagnosis.verificationEnteredInError': 'הוזנה בטעות',
  'diagnosis.mergedMark': 'מוזגה',
  'diagnosis.listLabel': 'אבחנות שנרשמו',
  'diagnosis.onset': 'התחלה',
  'diagnosis.recordedAt': 'נרשמה',
  'diagnosis.note': 'הערה',
  'diagnosis.add': 'הוספה',
  'diagnosis.addMain': 'הוספת אבחנה עיקרית',
  'diagnosis.addComplication': 'הוספת סיבוך',
  'diagnosis.addConcomitant': 'הוספת אבחנה נלווית',
  'diagnosis.addAdditional': 'הוספת אבחנה נוספת',
  'diagnosis.addTitle': 'אבחנה חדשה',
  'diagnosis.editTitle': 'עריכת אבחנה',
  'diagnosis.edit': 'עריכה',
  'diagnosis.editNamed': 'עריכת {name}',
  'diagnosis.remove': 'הסרה',
  'diagnosis.removeNamed': 'הסרת {name}',
  'diagnosis.fieldRole': 'תפקיד',
  'diagnosis.fieldDisplay': 'אבחנה מקודדת',
  'diagnosis.searchPlaceholder': 'חיפוש לפי קוד או שם אבחנה',
  'diagnosis.searchHint': 'יש להקליד לפחות שני תווים כדי לחפש.',
  'diagnosis.searching': 'מחפש אבחנות…',
  'diagnosis.searchFailed': 'טרמינולוגיית האבחנות אינה זמינה.',
  'diagnosis.searchEmpty': 'לא נמצאה אבחנה התואמת לחיפוש.',
  'diagnosis.searchResults': 'תוצאות חיפוש אבחנות',
  'diagnosis.fieldOnset': 'תאריך התחלה',
  'diagnosis.fieldNote': 'הערה',
  'diagnosis.fieldClinicalStatus': 'סטטוס קליני',
  'diagnosis.fieldVerification': 'אימות',
  'diagnosis.attributesTitle': 'פרטי האבחנה',
  'diagnosis.fieldDiagnosisKind': 'סוג אבחנה',
  'diagnosis.fieldDiseaseNature': 'אופי המחלה',
  'diagnosis.fieldBicausalType': 'סוג אבחנה נוספת',
  'diagnosis.fieldClinicalGroup': 'קבוצה קלינית',
  'diagnosis.fieldTopography': 'טופוגרפיה ICD-O-3',
  'diagnosis.fieldMorphology': 'מורפולוגיה ICD-O-3',
  'diagnosis.fieldTNM': 'TNM',
  'diagnosis.fieldRecurrence': 'הישנות',
  'diagnosis.fieldProgression': 'התקדמות',
  'diagnosis.selectPlaceholder': 'בחירה',
  'diagnosis.kindPreliminary': 'ראשונית',
  'diagnosis.kindClinical': 'קלינית',
  'diagnosis.kindFinal': 'סופית',
  'diagnosis.natureAcute': 'חריפה',
  'diagnosis.natureChronicFirst': 'כרונית, זוהתה לראשונה',
  'diagnosis.natureChronicEstablished': 'כרונית, ידועה מקודם',
  'diagnosis.groupI': 'I',
  'diagnosis.groupIA': 'IA',
  'diagnosis.groupIB': 'IB',
  'diagnosis.groupIPlus': 'I+',
  'diagnosis.groupII': 'II',
  'diagnosis.groupIIA': 'IIA',
  'diagnosis.groupIII': 'III',
  'diagnosis.groupIV': 'IV',
  'diagnosis.bicausalCompeting': 'מתחרה',
  'diagnosis.bicausalCombined': 'משולבת',
  'diagnosis.bicausalBackground': 'רקע',
  'diagnosis.oncologyTitle': 'אונקולוגיה',
  /* THE CATEGORY NAMES THE NEOPLASM, and the first three used to name nothing.
     `ממאירה` and `שפירה` are adjectives in the FEMININE, left standing after
     their noun was dropped; the reader supplies גידול, which is masculine, so
     the pair disagreed with the word it was read against. `במקום` was worse
     than wrong: it is the everyday adverb "instead", not a diagnosis category
     at all.

     The forms below are not invented. This product ships a mandatory Israeli
     medical Hebrew glossary (`seed/ai-prompt-files/glossary_he.txt`, seeded
     through `seed/ai-prompt-files/manifest.json`), and it settles all three:
     `malignant neoplasm of [site] → גידול ממאיר` (:1183), `benign → שפיר`
     (:1626), `tumor → גידול` and `malignant → ממאיר` in the masculine (:234),
     and `in situ → in situ (בלטינית)` (:1166) — the Latin term is kept because
     that is what Israeli oncology writes, which is also what the Russian
     catalogue does beside this one. The glossary offers `שאת ממאירה` as an
     alternative for OFFICIAL oncology documents; a chip on a diagnosis row is
     not one, so the primary form stands. The Israeli Ministry of Health writes
     the same words in its own published service names — `MRI מוח לגידול ממאיר`
     in `CodeSystem-medical-service-moh` of the IL-Core FHIR package this
     repository ships as an authoritative dictionary.

     The last two were already noun phrases in the shape English uses and agree
     with themselves (התנהגות and טיב), so they are left exactly as they were. */
  'diagnosis.oncologyCategoryMalignant': 'גידול ממאיר',
  'diagnosis.oncologyCategoryBenign': 'גידול שפיר',
  'diagnosis.oncologyCategoryInSitu': 'גידול in situ',
  'diagnosis.oncologyCategoryUncertain': 'התנהגות לא ודאית',
  'diagnosis.oncologyCategoryUnspecified': 'טיב לא מצוין',
  'diagnosis.oncologyFlags': 'סימוני אונקולוגיה',
  'diagnosis.topographyAuto': 'נגזר מקוד האבחנה.',
  'diagnosis.kindRequired': 'יש לבחור סוג אבחנה.',
  'diagnosis.natureRequired': 'יש לבחור את אופי המחלה.',
  'diagnosis.bicausalRequired': 'יש לבחור סוג אבחנה נוספת.',
  'diagnosis.clinicalGroupRequired': 'יש לבחור קבוצה קלינית.',
  'diagnosis.topographyRequired': 'יש לבחור טופוגרפיה ICD-O-3.',
  'diagnosis.morphologyRequired': 'יש לבחור מורפולוגיה ICD-O-3.',
  'diagnosis.oncologyChecking': 'בודק דרישות אונקולוגיות…',
  'diagnosis.oncologyUnavailable': 'טרמינולוגיית האונקולוגיה אינה זמינה.',
  'diagnosis.tnmChecking': 'טוען אפשרויות TNM…',
  'diagnosis.tnmUnavailable': 'אפשרויות TNM אינן זמינות.',
  'diagnosis.tnmRequired': 'יש לבחור TNM.',
  'diagnosis.selectionRequired': 'יש לבחור אבחנה מתוך טרמינולוגיית המרפאה.',
  'diagnosis.save': 'שמירת האבחנה',
  'diagnosis.saving': 'שומר…',
  'diagnosis.cancel': 'ביטול',
  'diagnosis.unsavedIntent': 'אבחנה \u2014 שינויים שלא נשמרו',
  /* The review family is worded with the review verb rather than the
     examination one on purpose. The published SOAP protocol ships an
     examination label in Hebrew, and `tests/no-compiled-protocol.test.ts`
     proves no published label is compiled into the bundle by searching the
     built bytes for it — a diagnosis string that happened to contain that word
     would fail that gate for a reason that has nothing to do with diagnoses. */
  'diagnosis.reviewTitle': 'סקירת ההקשר',
  'diagnosis.reviewDetail': 'רישום מי סקר את האבחנות ומתי. אינו משנה אף אבחנה.',
  'diagnosis.staleTitle': 'קשר האבחנות אינו מעודכן',
  'diagnosis.staleDetail':
    'הוא השתנה לאחר הסקירה האחרונה. אפשר לאשר אותו כפי שהוא, לאשרר אותו, או למזג את האבחנות לקשר מוסכם.',
  'diagnosis.accept': 'אישור',
  'diagnosis.confirm': 'אשרור',
  'diagnosis.merge': 'מיזוג',
  'diagnosis.reason': 'נימוק (רשות)',
  'diagnosis.decisionSubmit': 'רישום ההחלטה',
  'diagnosis.decisionCancel': 'ביטול',
  'diagnosis.mergeTitle': 'מיזוג קשר האבחנות',
  'diagnosis.mergeDetail':
    'ניסוח מחדש של האבחנות האלה כקשר הממוזג. אבחנה שלא נכללת אינה מנוסחת מחדש ונשארת כפי שהיא.',
  'diagnosis.mergeRestate': 'ניסוח מחדש של {name}',
  'diagnosis.mergeEmpty': 'יש לבחור אבחנה אחת לפחות לניסוח מחדש.',
  'diagnosis.mergeSubmit': 'מיזוג ורישום',
  'diagnosis.contextStatusCurrent': 'עדכני',
  'diagnosis.contextStatusStale': 'אינו מעודכן',
  'diagnosis.contextStatusAccepted': 'אושר',
  'diagnosis.contextStatusConfirmed': 'אושרר',
  'diagnosis.decisionsTitle': 'החלטות סקירה',
  'diagnosis.decisionAccept': 'אושר',
  'diagnosis.decisionConfirm': 'אושרר',
  'diagnosis.decisionMerge': 'מוזג',
  'diagnosis.readOnly': 'האבחנות ברשומה זו לקריאה בלבד.',
  'diagnosis.readOnlyDetail': 'מפגש שהושלם או סומן כשגוי נשאר קריא ואינו מקבל שינויים.',
  'diagnosis.mainConflict':
    'למפגש זה כבר קיימת אבחנה ראשית. יש לשנות את הקיימת, או לרשום אבחנה זו בתפקיד אחר.',
  'diagnosis.changedConcurrently':
    'קשר האבחנות השתנה במקום אחר בזמן שהמסך היה פתוח. יש לטעון מחדש כדי לראות את מצבו הנוכחי.',
  'diagnosis.writeReadOnly': 'מפגש זה אינו מקבל עוד שינויי אבחנות.',
  'diagnosis.writeForbidden': 'אין לך הרשאה לשנות אבחנות.',
  'diagnosis.writeSessionEnded': 'הפעילות הסתיימה. יש להתחבר שוב כדי להמשיך.',
  'diagnosis.writeGone': 'מפגש זה אינו זמין עוד.',
  'diagnosis.writeUnavailable': 'השירות אינו זמין. יש לנסות שוב בעוד רגע.',
  'diagnosis.writeInvalid': 'יש לבחור את האבחנה מתוך טרמינולוגיית המרפאה ולנסות שוב.',
  'diagnosis.writeAttributesInvalid': 'יש להשלים את פרטי האבחנה הנדרשים ולנסות שוב.',
  'diagnosis.writeFailed': 'לא ניתן היה לשמור את האבחנה. יש לנסות שוב.',
  'diagnosis.reload': 'טעינה מחדש של קשר האבחנות',

  'diagnosis.dictionaryTitle': 'מילון אבחנות',
  'diagnosis.dictionaryTitleTopography': 'טופוגרפיה ICD-O-3',
  'diagnosis.dictionaryTitleMorphology': 'מורפולוגיה ICD-O-3',
  'diagnosis.dictionaryTabCatalogueICD10': 'ICD-10',
  'diagnosis.dictionaryTabCatalogueICD9IL': 'ICD-9 IL',
  'diagnosis.dictionarySearchPlaceholder': 'קוד או שם',
  'diagnosis.dictionaryTopographyPlaceholder': 'קוד טופוגרפיה או אתר',
  'diagnosis.dictionaryMorphologyPlaceholder': 'קוד מורפולוגיה או היסטולוגיה',
  'diagnosis.dictionarySearchResults': 'תוצאות חיפוש אבחנות',
  'diagnosis.dictionaryBrowseHint': 'עיון בעץ. יש להקליד שלושה תווים, או תחילית קוד, כדי לחפש בכל המילון.',
  'diagnosis.dictionarySearching': 'מחפש במילון…',
  'diagnosis.dictionaryLoading': 'טוען…',
  'diagnosis.dictionaryLoadFailed': 'לא ניתן היה לקרוא את המילון.',
  'diagnosis.dictionaryEmptyLevel': 'אין קודים תחת קוד זה.',
  'diagnosis.sectionCount': '{count} נרשמו',
  'diagnosis.sectionEmpty': 'לא נרשמו.',
  'diagnosis.secondaryBlocked': 'יש לרשום תחילה אבחנה ראשית.',
  /*
   * QUICK ENTRIES — the Encounter as a phone offers it (#372). See the English
   * module for why these are the entry's vocabulary rather than the record's.
   */
  'encounterQuick.title': 'רישום מהיר',
  'encounterQuick.deskOnly':
    'כאן הביקור מוצג לקריאה בלבד. עורך הפרוטוקול, ההכתבה, ההפניות, השירותים וטופסי ההדפסה נמצאים במחשב.',
  'encounterQuick.note': 'הוספה לפרוטוקול',
  'encounterQuick.vitals': 'רישום סימנים חיוניים',
  'encounterQuick.task': 'יצירת משימה',
  'encounterQuick.save': 'שמירה',
  'encounterQuick.saving': 'שומר…',
  'encounterQuick.saveFailed': 'השמירה נכשלה. נסו שוב.',
  'encounterQuick.saveForbidden': 'אין לכם הרשאה לשמור זאת.',
  'encounterQuick.saveUnavailable': 'השרת לא הגיב. נסו שוב.',
  'encounterQuick.noteInto': 'נוסף אל: {protocol}',
  'encounterQuick.noteProtocol': 'פרוטוקול',
  'encounterQuick.noteChoose': 'בחרו פרוטוקול',
  'encounterQuick.noteNowhere':
    'כל הפרוטוקולים בביקור הזה חתומים. תיקון של אחד או פתיחת אחר נעשים במחשב.',
  'encounterQuick.noteNoFreeText':
    'בפרוטוקול הזה אין שדה טקסט חופשי, ולכן אי אפשר להוסיף לו כאן משפט.',
  'encounterQuick.noteConflict':
    'הפרוטוקול השתנה בזמן שהיריעה הייתה פתוחה. סגרו אותה, פתחו את הפרוטוקול מחדש והקלידו את הטקסט שוב.',
  'encounterQuick.protocolUnwritten': 'הפרוטוקול הזה עדיין לא נכתב בביקור הזה.',
  'encounterQuick.vitalLoading': 'טוען את מה שאפשר לרשום…',
  'encounterQuick.vitalCatalogueFailed': 'לא ניתן היה לקרוא את רשימת הסימנים החיוניים.',
  'encounterQuick.vitalEmpty': 'בגרסה הזו אי אפשר לרשום אף סימן חיוני.',
  'encounterQuick.vitalNothing': 'הזינו לפחות מדידה אחת.',
  'encounterQuick.vitalPartial': 'נרשם בשלמותו: מלאו את כל החלקים — {name} — או נקו אותם.',
  'encounterQuick.vitalNotNumber': 'אינו מספר: {name}',
  'encounterQuick.vitalRefused': 'השרת דחה את המדידות האלה. בדקו אותן ונסו שוב.',
  'encounterQuick.taskNoPractitioner':
    'החשבון שלכם אינו של קלינאי, ולכן אי אפשר להטיל עליו אחריות למשימה.',
  "record.patientDifference": "פרטי המטופל שונים מאלה שנשמרו בפרוטוקול.",
  "record.comparePatient": "הצגת ההבדלים",
  "record.patientComparisonUnavailable": "לא ניתן להשוות בין פרטי המטופל השמורים לפרטים הנוכחיים. הפרוטוקול עדיין זמין לצפייה.",
  "record.patientNameThen": "השם בפרוטוקול",
  "record.patientNameNow": "השם בכרטיס הנוכחי",
  "record.patientBirthDateThen": "תאריך הלידה בפרוטוקול (הגיל בביקור)",
  "record.patientBirthDateNow": "תאריך הלידה בכרטיס (הגיל בביקור)",
  "record.patientCorrectionContext": "תיקון יוצר מהדורה חדשה עם ההקשר העדכני של המטופל, כולל האנמנזה. יש לבדוק אותה לפני השלמת התיקון: ההשלמה מאשרת את מערך הפרוטוקולים הנוכחי של הביקור.",
  "record.keepPatientSnapshot": "השארה ללא שינוי",
}
